import Styled from 'components/Stock/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const TabsModule = ({ tab }) => {
  const { t } = useTranslation('stock');

  return (
    <Styled.Tabs>
      {/* <Link
        className={`item ${tab === 1 ? 'active' : ''}`}
        to={'/stock/buy/1/'}
      >
        {t('title.package_01')}
      </Link> */}

      {/* <Link
        className={`item ${tab === 3 ? 'active' : ''}`}
        to={'/stock/buy/3/'}
      >
        {t('title.package_03')}
      </Link> */}
    </Styled.Tabs>
  );
};

export default TabsModule;
